// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jj_LICzXBEqjjqj2XKKY tr:nth-child(odd) {\n\tbackground-color: #f6f6f6;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/fleet/VoyageDetailsScreen/components/TcPnl/TcPnl.module.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;AAC1B","sourcesContent":[".table tr:nth-child(odd) {\n\tbackground-color: #f6f6f6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": "jj_LICzXBEqjjqj2XKKY"
};
export default ___CSS_LOADER_EXPORT___;
